import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";


import bu1 from './../media/img/bu1.jpg'
import bu2 from './../media/img/bu2.jpg'
import bu3 from './../media/img/bu3.jpg'
import bu4 from './../media/img/bu4.jpg'
import bu5 from './../media/img/bu5.jpg'
import bu6 from './../media/img/bu6.jpg'
import bu7 from './../media/img/bu7.jpg'
import bu8 from './../media/img/bu8.jpg'
import bu9 from './../media/img/bu9.jpg'
import bu10 from './../media/img/bu10.jpg'

import sd1 from './../media/img/sd1.jpg'
import sd2 from './../media/img/sd2.jpg'
import sd3 from './../media/img/sd3.jpg'
import sd4 from './../media/img/sd4.jpg'
import sd5 from './../media/img/sd5.jpg'
import sd6 from './../media/img/sd6.jpg'
import sd7 from './../media/img/sd7.jpg'

import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import sui_wallet from './../media/img/suiwallet.png'
import sui_coin from './../media/img/suicoin.png'
import move_logo from './../media/img/move-logo.png'

import ton_logo from './../media/img/tn-logo-bg.png'
import ton_keeper_logo from './../media/img/tonkeeper_logo.png'
import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import bm1 from './../media/img/bm1.jpg'
import bm2 from './../media/img/bm2.jpg'


import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'
import { jeetcmds } from './../utilities/jeet-cmd'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="main-frame">
                    <div className="flex row  justify-center home-frame">
                        <div className="home-text flex column align-center">
                            {/* <img src={bwog_logo} className="home-text-logo-ant" alt="" data-aos="zoom-in" data-aos-duration="2000" /> */}
                            <div className="home-head-subhead" data-aos="fade-right" data-aos-duration="2000">
                                <h2>SUIYAN DOGE</h2>
                                <h3 className="text-align-center">0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA</h3>
                                {/* <h3>Next Generation Gaming Platform That Offers a Whole New Experience in the World of Cryptocurrency.</h3> */}
                            </div>
                            <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                <a href="https://x.com/suiyandoge" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={x_logo} alt="" />
                                </a>
                                <a href="https://t.me/suiyandoge" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tg_logo} alt="" />
                                </a>
                                <a href="https://movepump.com/token/0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={move_logo} alt="" />
                                </a>
                            </div>
                            {/* <div className="flex row justify-center align-center gap-5 copy-address-box" data-aos="fade-up" data-aos-duration="2000">
                                <img src={copy_icon} alt="" />
                                <p>0x760539FF254A88B925fd940C8Bc01069cf76069b</p>
                            </div> */}
                            {/* <div className="flex row gap-15" data-aos="fade-up" data-aos-duration="2000">
                                <a href="" target="_blank" className='btn-1'>
                                    Buy Now
                                </a>
                                <a href="" target="_blank" className='btn-sp'>
                                    Join Community
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="about" id="about">
                <div className="htb-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-text" data-aos="fade-right" data-aos-duration="2000">
                            {/* <h2>About Peki Inu</h2> */}
                            <h3>ABOUT SUIYAN DOGE!</h3>
                            <p>
                                SuiyanDoge is the next evolution in dog-themed meme coins, bringing the playful spirit of the original Doge onto the powerful Sui network. <br /><br/>
                                With Sui’s high-speed, low-cost transactions, SuiyanDoge aims to redefine meme culture by offering a smoother, faster, and more inclusive 
                                crypto experience. Powered by community-driven energy and a commitment to innovation, SuiyanDoge is more than just a token—it’s a celebration of 
                                what happens when cutting-edge blockchain tech meets the timeless charm of our favorite Shiba Inu dog. <br /><br />
                                Join the SuiyanDoge movement and help us unleash a new era of fun, utility, and unstoppable growth on the Sui blockchain!
                            </p>

                            {/* <a href="https://x.com/buirtcoin/" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Check out Tweet</span> 
                               <img src={twitter_icon} alt="" />
                            </a> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="htb" id="htb">
                <div className="htb-frame">
                    <div className="htb-header">
                        {/* <h2>Bart on the SUI Water Blockchain 🌊</h2> */}
                        <h3>How to buy SUIYAN DOGE</h3>
                    </div>
                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={sui_wallet} alt="" />
                                </div>
                                <h4>Sui Wallet</h4>
                                <p>
                                    To swap $KAMEHAMEHA on sui,
                                </p>
                                <a href="" target="_blank">Click here</a>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img className="htb-ton-logo" src={sui_coin} alt="" />
                                </div>
                                <h4>Buy SUI</h4>
                                <p>
                                    Buy SUI from your sui wallet or any centralized exchange of your choice. You can also get a friend to send you SUI
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={sd1} alt="" />
                                </div>
                                <h4>Swap $KAMEHAMEHA on DEX</h4>
                                <p>
                                    Now that you have SUI in your wallet, you can now swap SUI to $KAMEHAMEHA 
                                    on <a href="https://movepump.com/token/0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA" target="_blank">move.pump</a> using 
                                    our Contract Address
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section className="tk" id="tk">
                <div className="htb-frame">
                    <div className="cs-header" data-aos="fade-up" data-aos-duration="2000">
                        {/* <h2>Uniting the Strengths of Floki and Shiba</h2> */}
                        <h2>TOKENOMICS</h2>
                    </div>

                    <div className="tk-box" >
                        <h4>
                            TOKEN: KAMEHAMEHA <br />
                            • <br />
                            TOTAL INITIAL SUPPLY  10.000.000.000 <br />
                            • <br />
                            TOTAL TAXES : 0 <br />
                            • <br />
                            Liquidity Pool : Locked <br />
                        </h4>
                    </div>
                    <div className="tk-box" >
                        <h4>
                            CONTRACT ADDRESS : <br /><br />
                            <span>0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA</span>
                        </h4>
                    </div>

                    <div className="flex justify-center">
                        <a href="https://movepump.com/token/0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA" target="_blank" className="tk-btn">
                            Buy Now
                        </a>
                    </div>
                </div>
            </section>

            <section className="footer" id="footer">
                <div className="main-container">
                    
                        <div className="footer-box ">
                            <h2>$KAMEHAMEHA</h2>
                            <div className="flex justify-center">
                                <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                    <a href="https://x.com/suiyandoge" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/suiyandoge" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    {/* <a href="mailto:dhurovcoin@gmail.com" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={mail_icon} alt="" />
                                    </a> */}
                                    <a href="https://movepump.com/token/0x7542d64aafbc75aa3aaf4fb456774cb6af56cc260629fddc4a1322133063ce11::kamehameha::KAMEHAMEHA" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={move_logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <p className="copyright">SUIYANDOGE copyright 2024 - All Rights Reserved</p>
                    </div>

                    {/* <hr /> */}
                </div>
            </section>

        </div>
    );
}
 
export default Home;